export const RETRYABLE = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EAI_AGAIN',
  'ECONNREFUSED',
  'ESERVICE_UNAVAILABLE',
];



// WEBPACK FOOTER //
// ./src/gs-core/common/util/retryable.ts